import { ProductAttribute } from "../domain/ProductAttribute";
import { ProductAttribute as RestAttribute } from "../rest-model/ProductAttribute";
export class ProductAttributeAdapter {
    public adaptToDomain(restAttribute: RestAttribute): ProductAttribute {
        return new ProductAttribute(restAttribute);
    }
}
